import api from '../api'

export default {

  enquiry: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/partner-jobs/enquiry?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },


  booking: async () => {
    return api.get('api/partner-jobs/booking')
  },

  create: async job => {
    return api.post('api/partner-jobs',job)
  },


  getDetailed: async id => {
    return api.get('api/partner-jobs/' + id+ '/show')
  },

  createComment: async comment => {
    return api.post('api/partner-jobs/comment',comment)
  },


}
